

export function asc<T>(
    valueFunction: (value: T) => any
): (a: T, b: T) => number {
    return (a, b) => {
        const valueA = valueFunction(a);
        const valueB = valueFunction(b);

        if (valueA == null && valueB == null) {
            return 0;
        } else if (valueA == null) {
            return -1;
        } else if (valueB == null) {
            return 1;
        } else if (typeof valueA === 'number' && typeof valueB === 'number') {
            return valueA - valueB;
        } else if (valueA instanceof Date && valueB instanceof Date) {
            return valueA.getTime() - valueB.getTime();
        } else {
            return valueA.toString().localeCompare(valueB.toString());
        }
    };
}

export function desc<T>(
    valueFunction: (value: T) => any
): (a: T, b: T) => number {
    return (a, b) => -1 * asc(valueFunction)(a, b);
}

export function compareByMultiple<T>(
    comparators: ((a: T, b: T) => number)[]
): (a: T, b: T) => number {
    return (a, b) => {
        for (const comparator of comparators) {
            const result = comparator(a, b);
            if (result !== 0) {
                return result;
            }
        }
        return 0;
    };
}

export function sortBy<T>(array: T[], valueFunction: (value: T) => any): T[] {
    return array.sort(asc(valueFunction));
}

export function sortByDesc<T>(array: T[], valueFunction: (value: T) => any): T[] {
    return array.sort(desc(valueFunction));
}

export function compareNullsLast(
    a: string | number | null | undefined,
    b: string | number | null | undefined,
    direction: 'asc' | 'desc',
): number {
    if (a == null || b == null) {
        if (a == null && b == null) return 0;
        return a == null ? 1 : -1;
    }

    const comparison = typeof a === 'number' && typeof b === 'number'
        ? a - b
        : a.toString().localeCompare(b.toString(), undefined, {
            numeric: true,
            sensitivity: 'base',
        });
    return direction === 'asc' ? comparison : -comparison;
}
